import React from 'react';
import { Upload, FileCheck, File } from 'lucide-react';

const FileUpload = ({ label, description, file, onFileSelect, accept = ".csv" }) => {
  const isExcel = accept.includes('.xlsx') || accept.includes('.xls');

  const handleDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      onFileSelect(e.dataTransfer.files[0]);
    }
  };

  const handleChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      onFileSelect(e.target.files[0]);
    }
  };

  return (
    <div
      data-testid={`file-upload-${label.toLowerCase().replace(/\s+/g, '-')}`}
      className={`relative border-2 border-dashed rounded-[10px] p-6 flex flex-col items-center justify-center transition-all duration-200 cursor-pointer group
        ${file
          ? 'border-emerald-400 bg-[#ECFDF5]'
          : 'border-[#E5E5E5] bg-white hover:bg-[#F8F9FA] hover:border-[#A3A3A3]'
        }`}
      onDragOver={(e) => e.preventDefault()}
      onDrop={handleDrop}
      onClick={() => document.getElementById(`file-${label}`)?.click()}
    >
      <div className={`mb-3 p-3 rounded-[10px] transition-colors
        ${file
          ? 'bg-emerald-100'
          : 'bg-[#F8F9FA] group-hover:bg-[#E5E5E5]'
        }`}>
        {file ? (
          <FileCheck className="w-5 h-5 text-emerald-600" strokeWidth={1.5} />
        ) : (
          <Upload className="w-5 h-5 text-[#737373] group-hover:text-[#525252]" strokeWidth={1.5} />
        )}
      </div>
      <h3 className="text-sm font-semibold text-[#171717] mb-0.5 font-heading">{label}</h3>
      <p className="text-xs text-[#737373] mb-3">{description}</p>

      {file ? (
        <div className="flex items-center gap-2 px-3 py-1.5 rounded-lg bg-emerald-100">
          <File className="w-3 h-3 text-emerald-600" strokeWidth={1.5} />
          <span className="text-xs font-medium text-emerald-700 truncate max-w-[150px]">{file.name}</span>
        </div>
      ) : (
        <span className="text-xs text-[#A3A3A3]">
          {isExcel ? 'Drop Excel or click to browse' : 'Drop CSV/Excel or click to browse'}
        </span>
      )}

      <input
        type="file"
        accept={accept}
        className="hidden"
        id={`file-${label}`}
        onChange={handleChange}
      />
    </div>
  );
};

export default FileUpload;
